<div class="container-fluid mt-3 ">
    @if (Measure) {
    <div class="row justify-content-evenly">
        <!-- <span class="col-auto my-auto text-center">
      {{getSamplingModelLabel()}}
    </span> -->
        <span class="col-auto my-auto">
            <div class="row">
                <div class="col-auto p-0">{{Measure.OperatorsCount}}</div>
                <div class="col-auto px-1">
                    <mat-icon class="material-symbols-outlined"> person </mat-icon>
                </div>
            </div>
        </span>
        <span class="col-auto my-auto">
            <div class="row">
                <div class="col-auto p-0">{{Measure.CassetteCount}}</div>
                <div class="col-auto px-1">
                    <mat-icon class="material-symbols-outlined"> vignette </mat-icon>
                </div>
            </div>
        </span>
        <span class="col-auto  text-center">
            <div class="row justify-content-center">
                <div class="col-auto border rounded-1" [style.background]="Measure.Color">
                    <div class="fs-5 fw-bold" [style.color]="Measure.TextColor">
                        {{Measure.MeasureReferenceName}}
                    </div>
                </div>
            </div>
        </span>
    </div>
  
    <div class="row my-3">
        <button appPreventDoubleClick class="col" color="accent" mat-raised-button (throttledClick)="synchronizePumps()" [disabled]="!canSynchronizePumps()">
            Synchroniser les pompes
        </button>
    </div>

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Mode de prélèvement
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-select placeholder="" [(ngModel)]="SamplingMode" required (selectionChange)="changeSamplingMode($event)">
                @for (o of SamplingModeList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Localisation
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Measure.Localisation"
                      placeholder="Description de la localisation"></textarea>
        </mat-form-field>
    </div>

    <div class="row mt-3">
        <span class="ms-3 display-6 fw-bold">
            Opérateurs
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>APR</mat-label>
            <mat-select placeholder="APR" [(ngModel)]="Measure.ProcessSamplingCondition.Apr" required>
                @for (o of APRList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    @for (op of Measure.ProcessOperatorList; track op) {
    <div class="row border rounded-1 background-light mb-3 py-3">
        <div class="col-12">
            <div class="row">
                <mat-form-field class="col-6">
                    <mat-label>Prénom</mat-label>
                    <input matInput [(ngModel)]="op.FirstName" placeholder="Prénom">
                </mat-form-field>
                <mat-form-field class="col-6">
                    <mat-label>Nom</mat-label>
                    <input matInput [(ngModel)]="op.LastName" placeholder="Nom">
                </mat-form-field>
            </div>
            <div class="row justify-content-center">
                <button class="col-auto" matPrefix mat-flat-button aria-label="barcode" color="accent" (click)="deleteOperator(op)">
                    Supprimer l'opérateur
                </button>
            </div>
            <div class="row">
                <mat-slide-toggle class="m-1" [(ngModel)]="CompteurAvecHeure">Avec heures</mat-slide-toggle>
            </div>
            @for (k7 of op.CassetteList; track k7) {
            <div class="row">
                <button class="col-auto" matPrefix mat-icon-button aria-label="barcode" (click)="openBarcodeScanning(k7.Id, false)">
                    <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                </button>
                <div class="col">
                    <mat-label>Reférence cassette</mat-label>
                    <mat-form-field class="w-100">
                        <input matInput [(ngModel)]="k7.Reference" placeholder="Reférence cassette">
                        @if (!checkBarCode(k7.Reference)) {
                            <span class="error">
                              Format non reconnu
                            </span>
                        }
                    </mat-form-field>
                </div>
                <button class="col-auto" matPrefix mat-icon-button aria-label="delete" color="warn" (click)="deleteCassette(op, k7)">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
                <!-- <mat-form-field class="col">
            <mat-select placeholder="Type Tête Prélèvement" [(ngModel)]="k7.TypeTetePrelevement" required>
              <mat-option *ngFor="let o of TetePrelevementList; let i = index" [value]="i + 1">
                <span>{{o}}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="col">
            <input matInput [(ngModel)]="k7.RefTetePrelevement" placeholder="Ref Tête Prélèvement">
          </mat-form-field> -->
                <div class="col">
                    <mat-label>Intégrité</mat-label>
                    <mat-form-field class="w-100">
                        <mat-select placeholder="Intégrité" [(ngModel)]="k7.Integrite" required>
                            @for (o of IntegriteList; track o; let i = $index) {
                            <mat-option [value]="i + 1">
                                <span>{{o}}</span>
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col">
                    <div class="row">
                        <button class="col-auto" matPrefix mat-icon-button aria-label="barcode" (click)="openBarcodeScanning(k7.Id, true)">
                            <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                        </button>
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Référence pompe</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.Reference" (ngModelChange)="SelectedPumpCassettes.delete(k7)" placeholder="Référence pompe">
                            </mat-form-field>
                        </div>
                        @if (getPumpCassetteOptions(k7).length > 1) {
                        <div class="col-12">
                            <mat-form-field class="w-100">
                                <mat-label>Choisir cassette pour {{k7.Pompe.Reference}}</mat-label>
                                <mat-select [ngModel]="SelectedPumpCassettes.get(k7)" (selectionChange)="selectPumpCassette(k7, $event.value)">
                                    @for (candidate of getPumpCassetteOptions(k7); track candidate) {
                                    <mat-option [value]="candidate">{{getPumpCassetteLabel(candidate)}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        }
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Débit initial (L/min)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.DebitInitial" type="number" placeholder="Débit initial (L/min)">
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Débit final (L/min)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.DebitFinal" type="number" placeholder="Débit final (L/min)">
                            </mat-form-field>
                        </div>
                                              
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Compteur volume initial (L)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.CompteurVolInitial" type="number" placeholder="Compteur volume initial (L)">
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Compteur volume final (L)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.CompteurVolFinal" type="number" placeholder="Compteur volume final (L)">
                            </mat-form-field>
                        </div>

                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Débit moyen (L/min)</mat-label>
                                <input matInput [ngModel]="computeDebitMoy(k7.Pompe) | number:'1.1-1'" placeholder="Débit moyen (L/min)" disabled>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Ecart relatif &lt;5% </mat-label>
                                <input matInput [ngModel]="computeDebitMoyInf5Percent(k7.Pompe)" placeholder="Ecart relatif <5%" disabled="true">
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Volume total</mat-label>
                                <input matInput [ngModel]="computeVolumeTotal(k7.Pompe)" placeholder="Volume total" disabled="true">
                            </mat-form-field>
                        </div>
                        <div class="col">
                            @if (!CompteurAvecHeure) {
                            <mat-form-field class="w-100">
                                <mat-label>Compteur horaire initial (min)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireInitial" type="number" placeholder="Compteur horaire initial (min)">
                            </mat-form-field>
                            }
                        </div>
                        @if (CompteurAvecHeure) {
                        <div class="col-12 text-center">Compteur horaire initial</div>
                        }
                        @if (CompteurAvecHeure) {
                        <mat-form-field class="col-6">
                            <mat-label>Heures</mat-label>
                            <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireInitialHeures" type="number" placeholder="Heures">
                        </mat-form-field>
                        }
                        @if (CompteurAvecHeure) {
                        <mat-form-field class="col-6">
                            <mat-label>Minutes</mat-label>
                            <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireInitialMinutes" type="number" placeholder="Minutes" [formControl]="ValidMinutesForHoraireInitial">
                            @if (ValidMinutesForHoraireInitial.hasError('max') || ValidMinutesForHoraireInitial.hasError('min')) {
                            <mat-error>
                                0 à 59
                            </mat-error>
                            }
                        </mat-form-field>
                        }
                        <div class="col">
                            @if (!CompteurAvecHeure) {
                            <mat-form-field class="w-100">
                                <mat-label>Compteur horaire final (min)</mat-label>
                                <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireFinal" type="number" placeholder="Compteur horaire final (min)">
                            </mat-form-field>
                            }
                        </div>
                        @if (CompteurAvecHeure) {
                        <div class="col-12 text-center">Compteur horaire final</div>
                        }
                        @if (CompteurAvecHeure) {
                        <mat-form-field class="col-6">
                            <mat-label>Heures</mat-label>
                            <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireFinalHeures" type="number" placeholder="Heures">
                        </mat-form-field>
                        }
                        @if (CompteurAvecHeure) {
                        <mat-form-field class="col-6">
                            <mat-label>Minutes</mat-label>
                            <input matInput [(ngModel)]="k7.Pompe.CompteurHoraireFinalMinutes" type="number" placeholder="Minutes" [formControl]="ValidMinutesForHoraireFinal">
                            @if (ValidMinutesForHoraireFinal.hasError('max') || ValidMinutesForHoraireFinal.hasError('min')) {
                            <mat-error>
                                0 à 59
                            </mat-error>
                            }
                        </mat-form-field>
                        }
                        <div class="col">
                            <mat-form-field class="w-100">
                                <mat-label>Durée totale</mat-label>
                                <input matInput [ngModel]="computeDureeTotal(k7.Pompe)" placeholder="Durée totale" disabled="true">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row g-0">
                        <span class="text-center">PROGRAMMATION</span>
                        @for (ph of k7.PlageHoraireList; track ph) {
                        <div class="col-12">
                            <div class="row border rounded-1 my-1 py-2 g-0" [style.background-color]="ph.Color">
                                <span class="col text-center">{{ph.Debut.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                                <span class="col text-center">{{ph.Fin.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                                <a class="col-auto btn-close me-1" (click)="deletePlage(ph, k7, op)"></a>
                            </div>
                        </div>
                        }
                        <div class="col-12">
                            <div class="row justify-content-center">
                                <button appPreventDoubleClick class="col-auto" color="primary" mat-fab (throttledClick)="openPlageHoraireDialog(op, k7.Id!)">
                                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="col mt-2">
                            <mat-form-field class="w-100 ">
                                <mat-label>TOTAL (min)</mat-label>
                                <input matInput [ngModel]="getTotal(k7)" placeholder="TOTAL (min)" readonly>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            }
            <div class="row">
                <span class="text-center">TACHE</span>
                <div class="col">
                    @for (t of op.TaskList; track t) {
                    <div class="">
                        <div class="row border rounded-1 my-1 py-2 g-0" [style.background-color]="t.Color">
                            <span class="text-center"> {{getPostureLabel(t.Posture)}}</span>
                            <span class="text-center"> {{t.Description}}</span>
                            <span class="col text-center">{{t.StartedOn.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                            <span class="col text-center">{{t.EndedOn.toLocaleString(undefined, { day: 'numeric', month: 'numeric', hour: 'numeric', minute: 'numeric' })}}</span>
                            <a class="col-auto btn-close me-1" (click)="deleteTask(op, t)"></a>
                        </div>
                    </div>
                    }
                    <div class="row justify-content-center">
                        <button appPreventDoubleClick class="col-auto" color="primary" mat-fab (throttledClick)="openTaskDialog(op)" [disabled]="!canCreateTask(op)">
                            <mat-icon class="material-symbols-outlined">add</mat-icon>
                        </button>
                    </div>

                    <!-- <mat-form-field class="col">
          <input matInput [ngModel]="getTotal()" placeholder="TOTAL (min)" readonly>
        </mat-form-field> -->
                    <!-- @if (Measure.ProcessOperatorList.length > 1) {
                    <div class="my-3 mx-5" style="background: gray; height: 3px;"></div>
                    } -->
                </div>
            </div>
        </div>
    </div>
    }

    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Conditions de prélèvement
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <button appPreventDoubleClick class="col-auto" matPrefix mat-icon-button aria-label="barcode" (click)="openBarcodeScanning(undefined, false)">
            <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
        </button>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Réf Témoin</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.Temoin" placeholder="Réf Témoin">
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Contexte</mat-label>
                <mat-select placeholder="Contexte" [(ngModel)]="Measure.ProcessSamplingCondition.ExpositionClimatique" (selectionChange)="changeExposition($event)" required>
                    @for (o of ExpositionClimatiqueList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Vitesse vent début (m/s)</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.VitesseVent1" type="number" placeholder="Vitesse vent début (m/s)"
                       [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur">
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Vitesse vent milieu (m/s)</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.VitesseVent2" type="number" placeholder="Vitesse vent milieu (m/s)"
                       [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur">
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Vitesse vent fin (m/s)</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.VitesseVent3" type="number" placeholder="Vitesse vent fin (m/s)"
                       [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur">
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Météo</mat-label>
                <mat-select placeholder="Météo" [(ngModel)]="Measure.ProcessSamplingCondition.Meteo" required
                            [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur">
                    @for (o of MeteoList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Hygrométrie début (%)</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.Hygrometrie1" type="text" step="1" placeholder="Hygrométrie début (%)"
                       [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur" numbersOnly inputmode="numeric">
            </mat-form-field>
        </div>
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Hygrométrie milieu (%)</mat-label>
                <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.Hygrometrie2" type="text" placeholder="Hygrométrie milieu (%)"
                       [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur" numbersOnly inputmode="numeric">
            </mat-form-field>
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Hygrométrie fin (%)</mat-label>
                    <input matInput [(ngModel)]="Measure.ProcessSamplingCondition.Hygrometrie3" type="text" placeholder="Hygrométrie fin (%)"
                           [disabled]="Measure.ProcessSamplingCondition.ExpositionClimatique === EExpositionClimatique.Interieur" numbersOnly inputmode="numeric">
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Observation de la mesure OP
        </span>
    </div>

    <div class="row rounded-1 background-light mb-3 py-3">
        <!-- <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Entrée Zone</mat-label>
                <mat-select placeholder="Entrée Zone" [(ngModel)]="Measure.Securite.EntreeZone" required>
                    @for (o of EntreProcessList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div> -->

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Moyen d'observation</mat-label>
                <mat-select placeholder="Moyen d'observation" [(ngModel)]="Measure.Securite.MoyenObservation" required>
                    @for (o of MoyenObservationList; track o; let i = $index) {
                    <mat-option [value]="i">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>APR du préleveur</mat-label>
                <mat-select placeholder="APR du préleveur" [(ngModel)]="Measure.Securite.Epi" required>
                    @for (o of EPIList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <!-- <mat-form-field class="col">
  <input matInput [(ngModel)]="Measure.PoseSecurite.EntreeZone" placeholder="EntreeZone">
</mat-form-field> -->
        <!-- <mat-form-field class="col">
<input matInput [(ngModel)]="Measure.PoseSecurite.Epi" placeholder="Epi">
</mat-form-field> -->
        <div class="col">
            <mat-form-field class="w-100">
                <mat-label>Durée de port d'APR</mat-label>
                <input matInput [(ngModel)]="Measure.Securite.DureeExposition" type="number" placeholder="Durée de port d'APR">
            </mat-form-field>
        </div>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col">
            <mat-label>Observation</mat-label>
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" [(ngModel)]="Measure.Observation" placeholder="Observation"></textarea>
        </mat-form-field>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col" color="warn" mat-raised-button (throttledClick)="cancelMeasure()">
            Mesure non réalisée
        </button>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col" color="primary" mat-raised-button (throttledClick)="save()" [disabled]="LoadingTask.IsLoading > 0 || !canSave()">
            Enregistrer
        </button>
    </div>
    }
</div>